import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useNavigate} from 'react-router'

import {handleError} from '../../shared/helpers/errorHandling'
import {useAxios} from '../../shared/hooks/useApi'
import {NewComment} from '../types'

import {QueryKey} from './useComments'

export const useCreateComment = (
  locationId: string,
  options?: UseMutationOptions<never, AxiosError, NewComment>
) => {
  const axiosInstance = useAxios()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation<never, AxiosError, NewComment>({
    mutationFn: async (newCommentData) => {
      const path = `/kpi/dashboard/comments/${locationId}`

      const response = await axiosInstance.post<never>(path, newCommentData)
      return response.data
    },
    onError: (err) => handleError(err, navigate),
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey]})
      await options?.onSuccess?.(data, variables, context, mutation)
    },
    ...options
  })
}
